const exportList = {
    path: 'exportList',
    component: resolve => require(['../../../../../pages/admin/merchant/exportList'], resolve),
    meta: {
        requireAuth: true
    }
}

export default exportList
